<!--
 * @Author: Junjie
 * @Date: 2022-06-24 13:07:48
 * @LastEditTime: 2023-08-30 15:31:37
 * @email: 781433561@qq.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/general/DevGeneral.vue
-->
<template>
  <div>
    <a-row :gutter="[16, 16]">
      <a-col :span="6">
        <chart-card :total="`${devUptimeRate}%`" title="设备完好率">
          <a-icon @click="showStatReport({}, 'devHealthStat')" slot="action" type="info-circle" />
          <div flag="down">
            <a-progress
              :percent="devUptimeRate"
              :stroke-color="{
                '0%': '#FF780A',
                '100%': '#73BF69'
              }"
              :width="90"
            />
          </div>
        </chart-card>
      </a-col>
      <a-col :span="6">
        <chart-card :total="`${devAllInfo.maintenanceCompletionRate || 100}%`" title="保养完成率">
          <a-icon @click="handleToUrl('/maintenance/task')" slot="action" type="info-circle" />
          <div flag="down">
            <a-progress
              :percent="devAllInfo.maintenanceCompletionRate"
              :stroke-color="{
                '0%': '#FF780A',
                '100%': '#73BF69'
              }"
              :width="90"
            />
          </div>
        </chart-card>
      </a-col>
      <a-col :span="6">
        <chart-card
          :total="`${devAllInfo.defectRegistrationNum} / ${devAllInfo.defectEliminateNum}`"
          title="缺陷登记/消除"
        >
          <a-icon @click="handleToUrl('/defect/defRegister')" slot="action" type="info-circle" />
          <div flag="down">
            <a-progress
              :percent="
                devAllInfo.defectRegistrationNum
                  ? ((devAllInfo.defectEliminateNum * 100) / devAllInfo.defectRegistrationNum).toFixed(2)
                  : 100
              "
              :stroke-color="{
                '0%': '#FF780A',
                '100%': '#73BF69'
              }"
              :width="90"
            />
          </div>
        </chart-card>
      </a-col>
      <a-col :span="6">
        <chart-card :total="`${devAllInfo.devAlarmNum}`" title="告警设备总数">
          <a-icon @click="showStatReport({}, 'alarmDevStat')" slot="action" type="info-circle" />
        </chart-card>
      </a-col>
    </a-row>

    <a-row :gutter="[16, 16]">
      <a-col :span="8">
        <a-card size="small" style="width: 100%" title="本月缺陷统计">
          <a-button slot="extra" type="link">
            <router-link to="/defect/defRegister">更多</router-link>
          </a-button>
          <v-chart :option="defectBarOpts" style="width: 100%; height: 200px; background-color: #fff" />
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card size="small" style="width: 100%" title="设备运行时间">
          <a-button @click="showStatReport({}, 'devRunningStat')" slot="extra" type="link">详情</a-button>
          <v-chart :option="runningTimeTop10BarOpts" style="width: 100%; height: 200px; background-color: #fff" />
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card size="small" style="width: 100%" title="告警设备TOP10">
          <a-button slot="extra" @click="showStatReport({}, 'alarmDevStat')" type="link"
            >更多
            <!-- <router-link to="/alert/history">更多</router-link> -->
          </a-button>
          <v-chart :option="devAlarmTop10BarOpts" style="width: 100%; height: 200px; background-color: #fff" />
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card size="small" style="width: 100%" title="备品备件库存预警">
          <a-button slot="extra" type="link">
            <router-link to="/bpbj/Inventory">更多</router-link>
          </a-button>
          <dev-inventory-list ref="devInventory" viewType="noShow" />
        </a-card>
      </a-col>
    </a-row>

    <iframe-drawer ref="iframeDrawer"></iframe-drawer>
  </div>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import moment from 'dayjs'
import ChartCard from '@/components/ChartCard'
import MiniProgress from '@/components/chart/MiniProgress'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DevInventoryList from '@/views/bpbj/vue/DevInventoryList'
import { validatenull, validatenotnull } from '@/utils/validate'

const defectLevel = {
  '1': '一般',
  '2': '严重',
  '3': '危急'
}
export default {
  name: 'DevGeneral',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    ChartCard,
    MiniProgress,
    DevInventoryList
  },
  data() {
    return {
      month: moment().format('YYYY-MM'),

      devAllInfo: {
        devUptimeRate: 100,
        maintenanceCompletionRate: 100,
        defectRegistrationNum: 0,
        defectEliminateNum: 0,
        devAlarmNum: 0,
        devUseRate: 0
      },
      devUptimeRate: 100,
      devClassCntPieOpts: {},
      runningTimeTop10BarOpts: {},
      devAlarmTop10BarOpts: {},
      defectBarOpts: {},
      url: {
        getDevStatInfo: '/device/devBillboards/getCountNumInfo',
        getDevClassCount: '/device/devBillboards/getDevRuntimeCountInfo',
        getDevRuntimeCountInfo: '/device/devBillboards/getDevRuntimeCountInfo',
        getDevAlarmCountInfo: '/device/devBillboards/getFaultyDevCountInfo',
        getDefectCount: '/device/devBillboards/getFaultyCountInfo',
        list: '/spareparts/devBpbjInfo/stock/list',
        devUptimeRateUrl: '/device/devList/getDevUptimeRate',
        getReportUrl: '/custom/commonOnlReport/list'
      },
      reportUrl: {}
    }
  },
  created() {
    const that = this
    getAction(this.url.getReportUrl, { reportGroup: 'drill-ana' }).then(res => {
      if (res.success && res.result) {
        res.result.records.forEach(rep => {
          that.reportUrl[rep.shortName] = rep.url
        })
      }
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.devInventory.stockFlag = true
      this.$refs.devInventory.insufficientChange()
    })
  },
  methods: {
    loadData() {
      this.getDevStatInfo()
      this.getDevRuntimeCountInfo()
      this.getDevAlarmCountInfo()
      this.getDevClassCount()
      this.getDefectCount()
      this.$nextTick(() => {
        this.$refs.devInventory.stockFlag = true
        this.$refs.devInventory.insufficientChange()
      })
      this.getDevUptimeRate()
    },
    getDevStatInfo() {
      getAction(this.url.getDevStatInfo, {
        month: this.month
      }).then(res => {
        this.devAllInfo = Object.assign(this.devAllInfo, res.result)
      })
    },
    getDevUptimeRate() {
      getAction(this.url.devUptimeRateUrl, {}).then(res => {
        if (res.success) {
          this.devUptimeRate = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getDevClassCount() {},
    getDevRuntimeCountInfo() {
      getAction(this.url.getDevRuntimeCountInfo, {
        month: this.month
      }).then(res => {
        const xAxis = []
        const series = []
        res.result.forEach(item => {
          xAxis.push(item.devName)
          series.push(item.runTimeNum)
        })
        this.runningTimeTop10BarOpts = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: '4%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '运行时间(分钟)'
            }
          ],
          series: [
            {
              name: '运行时间(分钟)',
              type: 'bar',
              barWidth: '60%',
              barMaxWidth: 20,
              data: series
            }
          ]
        }
      })
    },
    getDevAlarmCountInfo() {
      getAction(this.url.getDevAlarmCountInfo, {
        month: this.month
      }).then(res => {
        const xAxis = []
        const series = []
        res.result.forEach(item => {
          xAxis.push(item.devName)
          series.push(item.flawNum)
        })
        this.devAlarmTop10BarOpts = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: '4%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '告警次数'
            }
          ],
          series: [
            {
              name: '告警次数',
              type: 'bar',
              barWidth: '60%',
              barMaxWidth: 20,
              data: series
            }
          ]
        }
      })
    },
    getDefectCount() {
      getAction(this.url.getDefectCount, {
        month: this.month
      }).then(res => {
        const xAxis = []
        const finished = []
        const unfinished = []
        res.result.forEach(item => {
          xAxis.push(defectLevel[item.def_level])
          finished.push(item.finished)
          unfinished.push(item.unfinished)
        })
        const series = [
          {
            name: '已处理',
            type: 'bar',
            barWidth: '60%',
            barMaxWidth: 20,
            data: finished,
            stack: '总计'
          },
          {
            name: '未处理',
            type: 'bar',
            barWidth: '60%',
            barMaxWidth: 20,
            data: unfinished,
            stack: '总计'
          }
        ]
        this.defectBarOpts = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: '4%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xAxis,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '缺陷数量'
            }
          ],
          series: series
        }
      })
    },
    handleToUrl(url, params) {
      if (validatenull(url)) {
        return
      }
      this.$router.push({ path: url, query: params })
    },
    showStatReport(record, reportKey, key) {
      let url = this.reportUrl[reportKey]
      if (!url) {
        this.$message.warning('未找到统计信息配置')
      }
      if (key) {
        if (url.indexOf(`${key}`) > -1) {
          url = url.replace(`\$\{${key}\}`, record[key])
        } else {
          url += `&${key}=${record[key]}`
        }
      }

      url = url.replace('${tenant_id}', this.$ls.get('TENANT_ID'))
      this.$refs['iframeDrawer'].show(url)
    }
  }
}
</script>

<style lang="less" scoped>
.detail-layout {
  margin-left: 44px;
}
.text {
  color: rgba(0, 0, 0, 0.45);
}

.heading {
  color: rgba(0, 0, 0, 0.85);
  font-size: 20px;
}

.no-data {
  color: rgba(0, 0, 0, 0.25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}

.mobile {
  .detail-layout {
    margin-left: unset;
  }
  .status-list {
    text-align: left;
  }
}
</style>
